import { I18nComponente } from "@/types/gerais"

export const AListaDeItensi18n: I18nComponente = {
  "pt-BR": {
    verTodosOsProjetos: "ver todos os projetos",
  },
  "es-CO": {
    verTodosOsProjetos: "ver todos los proyectos",
  }
}
